export function addNormalizedData(draft, entities) {
  const ids = entities.map(it => it.id);
  entities.forEach(entity => {
    draft.byId[entity.id] = entity;
  });
  draft.ids = ids;
}
export function setNormalizedData(draft, entities) {
  draft.byId = {};
  addNormalizedData(draft, entities);
}
export const entitiesFromStructure = data => data.ids.map(id => data.byId[id]);
export const initialEntityStructure = {
  byId: {},
  ids: []
};